import { DependencyList, useEffect } from 'react';

type AsyncEffectCallback = (signal: AbortSignal) => Promise<void>;

type AsyncEffectOptions = {
  onError?: (error: unknown) => void;
};

export function useAsyncEffect(
  effect: AsyncEffectCallback,
  dependencies: DependencyList = [],
  options?: AsyncEffectOptions
): void {
  useEffect(() => {
    const abortController = new AbortController();

    void effect(abortController.signal).catch((error) => {
      if (abortController.signal.aborted) {
        return;
      }

      options?.onError?.(error);
    });

    return () => {
      abortController.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
}
